import styled from 'styled-components';
import RecipeCard from '../RecipeCard';
import {SearchQuizSize } from '../../Sizes';
import {CustomInstantSearch} from '../../molecules/Searchbar';
import {DividerColor, SurfaceColor} from '../../Colors';

const defaultStyle =  {
	Wrapper : styled.div`
	`,
	SearchbarWrapper : styled.div`
		padding : 1rem;
		display : flex;
		justify-content : center;
	`,
	CardlistWrapper : styled.div`
		width : ${SearchQuizSize.Width};
		background-color : ${SurfaceColor};
		border-top : 1px solid ${DividerColor};
	`,
	RecipeCard : styled(RecipeCard)`
		border-bottom : 1px dotted ${DividerColor};
		padding : 1rem;
	`,
	Sentinel : styled.div`
	`,
	CustomInstantSearch : styled(CustomInstantSearch).attrs({
		placeholder : 'Search recipe'
	})`
        width : 80%;
    `,
};

const mobileStyle = {
	SearchbarWrapper : styled.div`
		padding : 1rem;
	`,
	CardlistWrapper : styled.div`
		width : ${SearchQuizSize.Width};
		background-color : ${SurfaceColor};
		margin-top : 1rem;
		border-top : 1px solid ${DividerColor};
	`,
	CustomInstantSearch : styled(CustomInstantSearch).attrs({
		placeholder : 'Search recipe'
	})`
        width : 100%;
    `,
};

export default defaultStyle;
export {mobileStyle};